import { useContext } from "react";

import { Button, Skeleton } from "@upstageai/ui";

import { EndpointType } from "../../constants/Endpoints";
import {
  getEndpointViewTypes,
  getViewLabel,
  ViewType,
} from "../../constants/EndpointViews";
import { ValidatorFileContext } from "../../hooks/useFile";

// 선택적: 버튼 개수를 props로 받는 버전
interface ResultViewSelectSkeletonProps {
  buttonCount?: number;
}
export const ResultViewSelectSkeletonWithCount = ({
  buttonCount = 3,
}: ResultViewSelectSkeletonProps) => {
  return (
    <div className="flex h-9 items-center">
      {[...Array(buttonCount)].map((_, index) => (
        <Skeleton key={index} className="mr-1 h-8 w-[80px] rounded-md" />
      ))}
    </div>
  );
};

// 뷰 선택 버튼 컴포넌트
export const ResultViewSelect = ({
  view,
  setView,
  endpointType,
  onViewChange,
}: {
  view: ViewType;
  setView: (view: ViewType) => void;
  endpointType: EndpointType;
  onViewChange: () => void;
}) => {
  const { inferenceState } = useContext(ValidatorFileContext);
  const viewTypes = getEndpointViewTypes(endpointType);

  if (inferenceState.isInfering)
    return <ResultViewSelectSkeletonWithCount buttonCount={viewTypes.length} />;

  return (
    <div className="flex">
      {viewTypes.map(viewType => {
        return (
          <Button
            key={viewType}
            variant="ghost"
            onClick={() => {
              setView(viewType);
              onViewChange();
            }}
            className={viewType === view ? "bg-muted-light" : ""}
          >
            {getViewLabel(viewType)}
          </Button>
        );
      })}
    </div>
  );
};
